import React, { useEffect, useRef, useState } from 'react';
import '../styles/Hero.css';
import { IMAGE_PATHS } from '../config/paths';
import { lang } from '../lang';

const RAYO_ANIMATION_DURATION = 500; // ms (slower)
const GRAY_FADEIN_DELAY = 100; // ms after rayo
const LOGO_FADEIN_DELAY = 400; // ms after gray
const TEXT_FADEIN_DELAY = 700; // ms after logo

const Hero: React.FC = () => {
    const [rayoDone, setRayoDone] = useState(false);
    const [grayVisible, setGrayVisible] = useState(false);
    const [logoVisible, setLogoVisible] = useState(false);
    const [textVisible, setTextVisible] = useState(false);
    const [rayoVisible, setRayoVisible] = useState(false);
    const rayoRef = useRef<SVGPolylineElement>(null);

    useEffect(() => {
        // Animate the rayo
        const rayo = rayoRef.current;
        if (rayo) {
            const length = 3000; // Valor fijo
            rayo.style.strokeDasharray = String(length);
            rayo.style.strokeDashoffset = String(length);
            rayo.style.transition = '';
            rayo.style.opacity = '0';
            setTimeout(() => {
                setRayoVisible(true);
                rayo.style.opacity = '1';
                rayo.style.transition = `stroke-dashoffset ${RAYO_ANIMATION_DURATION}ms linear`;
                rayo.style.strokeDashoffset = '0';
            }, 50);
            setTimeout(() => setRayoDone(true), RAYO_ANIMATION_DURATION + 50);
        }
    }, []);

    useEffect(() => {
        if (rayoDone) {
            const grayTimeout = setTimeout(() => setGrayVisible(true), GRAY_FADEIN_DELAY);
            const logoTimeout = setTimeout(() => setLogoVisible(true), GRAY_FADEIN_DELAY + LOGO_FADEIN_DELAY);
            const textTimeout = setTimeout(() => setTextVisible(true), GRAY_FADEIN_DELAY + LOGO_FADEIN_DELAY + TEXT_FADEIN_DELAY);
            return () => {
                clearTimeout(grayTimeout);
                clearTimeout(logoTimeout);
                clearTimeout(textTimeout);
            };
        }
    }, [rayoDone]);

    return (
        <section className="hero">
            <div className={`hero-bg-gray gray-fadein${grayVisible ? ' visible' : ''}`} />
            <svg className="hero-bg-lightning" viewBox="0 0 1124 612" width="100%" height="100%" preserveAspectRatio="none" role="img" aria-label="Fondo animado con efecto de rayo">
                <polygon points="0,0 1500,0 1124,180 650,350 900,350 -0,612" fill="#000" /> {/* Black background */}
                <polyline
                    ref={rayoRef}
                    points="1750,0 650,350 900,350 -670,770"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="3"
                    transform="rotate(-2 562 306) translate(-30,10)"
                    className={`rayo-anim${!rayoVisible ? ' rayo-anim-initial' : ''}`}
                />
            </svg>
            <div className={`hero-title-img-wrapper fadein ${logoVisible ? 'visible' : ''}`}>
                <img 
                    src={IMAGE_PATHS.TITLE} 
                    alt="Terral Team - Estudio creativo de videojuegos indie y diseño 3D" 
                    className="hero-title-img"
                />
            </div>
            <div className={`hero-content-center fadein ${textVisible ? 'visible' : ''}`}>
                <h1 className="hero-main-text">
                    {lang.Hero.mainText.split(',').map((line, i) => (
                        <React.Fragment key={i}>
                            {line.trim()}{i === 0 && <br />}
                        </React.Fragment>
                    ))}
                </h1>
            </div>
        </section>
    );
};

export default Hero; 